import React, { useState, useEffect } from "react";
import moment from "moment";
import { Redirect } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import AaCottonLogo from "../../assets/img/aaCottonLogo.jpg";
import html2canvas from "html2canvas";
import {
  Button,
  Col,
  Row,
  Container,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import ReactstrapTable from "../Tables/ReactstrapTable/DataTable";
import { check_Bussiness_Permission } from "../../Helper";
var companySymbolCurrency = localStorage.getItem("companySymbolCurrency");
var customerName = localStorage.getItem("firstName");
var loginId = localStorage.getItem("username");
var companyName = localStorage.getItem("companyName");
let currentDate = moment(new Date()).format("YYYY-MM-DD");
if (loginId === "SJM_Admin@gmail.com") {
  customerName = loginId.toString().replace(":", "").split("@")[0];
}
export default function PrintReports(props) {
  console.log("props :>> ", props);
  const [data, setData] = useState({
    dynamicInvMessage: props?.location?.state?.dynamicInvMessage,
    reportName: props?.location?.state?.reportName,
    table: [],
    companyName: localStorage.getItem("companyName"),
    // date: new Date(),
    criteria: props?.location?.state?.criteria,
    criteriaString: props?.location?.state?.criteriaString || "All",
    hidePdfBtn: props?.location?.state?.hidePdfBtn || 0,
  });

  const [screenTableData, setScreenTableData] = useState([]);
  const [isAACotton, setIsAACotton] = useState(false);
  useEffect(async () => {
    // console.log(props);
    let logInStatus = false;
    const token = localStorage.getItem("token");
    let reportPrintGoBackUrl = localStorage.getItem("reportPrintGoBackUrl");
    console.log(reportPrintGoBackUrl);
    console.log(props?.location?.state?.data);
    // return;
    const screenPrintData = props?.location?.state?.data;
    console.log(screenPrintData);
    if (screenPrintData) {
      const modifiedData = screenPrintData.map((row, index, array) => {
        if (
          index > 0 &&
          row.master_invoice_id === array[index - 1].master_invoice_id &&
          row.FINISHED_ITEM === array[index - 1].FINISHED_ITEM &&
          row.master_invoice_id > -1
        ) {
          return {
            ...row,
            INVOICE_DATE: "",
            INVOICE_NO: "",
            FINISHED_ITEM: "",
          };
        }
        return row;
      });
      setScreenTableData(modifiedData); // Update state instead of a variable
    }
    if (token != null) {
      logInStatus = true;
    }
    if (logInStatus === false) {
      return <Redirect to="/login" />;
    }
    if (!props?.location?.state?.data) {
      props.history.push({
        pathname: reportPrintGoBackUrl,
      });
    } else {
      reportPrintGoBackUrl = props?.location?.state?.goBackUrl;
      localStorage.setItem("reportPrintGoBackUrl", reportPrintGoBackUrl);
    }
    // manipulateData();
    // getdata();
    // getAccountsSummary();
    await checkBussinessPermission();
  }, []);

  const goBackFun = () => {
    let pathName = props?.location?.state?.goBackUrl;
    props.history.push({
      pathname: pathName,
    });
  };

  const downloadPDF = () => {
    const alignmentsMaping = props?.location?.state?.headerKeyMap;

    const columnStyles = alignmentsMaping.reduce((acc, item, index) => {
      acc[index] = {
        halign: item.align || "left",
        cellWidth: item.width || "auto",
      };
      return acc;
    }, {});

    const headers = [
      props?.location?.state?.headers.map((header) =>
        typeof header === "object" && header?.value ? header?.value : header
      ),
    ];

    const rawData = props?.location?.state?.data;
    const pdfData = props.location.state.pdfDataArray;
    const pdfDataArray = pdfData ? pdfData : rawData;

    const modifiedPdfDataArray = pdfDataArray.map((row, index, array) => {
      if (
        index > 0 &&
        row.FINISHED_ITEM &&
        row.FINISHED_ITEM === array[index - 1].FINISHED_ITEM
      ) {
        return {
          ...row,
          INVOICE_DATE: "",
          INVOICE_NO: "",
          FINISHED_ITEM: "",
        };
      }
      return row;
    });

    const rowsvalueExtracted = modifiedPdfDataArray.map((item) =>
      Object.values(item)
    );

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a2",
    });

    const reportName = data.reportName;

    doc.setFontSize(25);
    doc.text("A.A. COTTON MILLS LTD", 14, 15);
    doc.setFontSize(20);
    doc.text(reportName, 14, 25);
    doc.setFontSize(20);
    doc.text(data.criteriaString, 14, 35);

    var img = new Image();
    img.src = AaCottonLogo;

    const pageWidth = doc.internal.pageSize.getWidth();
    var imgWidth = 35;
    var imgHeight = 30;
    var marginX = 14;

    var xPosition = pageWidth - imgWidth - marginX;
    var yPosition = 10;

    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-US");
    let username = localStorage.getItem("username");

    doc.setFontSize(18);
    doc.setTextColor(0, 0, 0);

    doc.text(`Generated By: ${username}`, xPosition - 5, 15, {
      align: "right",
    });
    doc.text(`Generated on: ${formattedDate}`, xPosition - 37, 25, {
      align: "right",
    });

    doc.addImage(img, "JPEG", xPosition, yPosition, imgWidth, imgHeight);

    const leftMargin = 14;
    const rightMargin = 14;
    const tableWidth = pageWidth - leftMargin - rightMargin;

    doc.autoTable({
      head: headers,
      body: rowsvalueExtracted,
      startY: 45,
      theme: "grid",
      margin: {
        left: leftMargin,
        right: rightMargin,
      },
      tableWidth: tableWidth,
      styles: {
        fontSize: 15,
        cellPadding: 4,
        valign: "middle",
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        halign: "center",
        valign: "middle",
        fontStyle: "bold",
        lineWidth: 0.2,
        lineColor: [200, 200, 200],
      },
      columnStyles,
      didDrawPage: (data) => {
        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber}`,
          10,
          410
        );
      },
      didParseCell: (data) => {
        if (data.row.raw[2] === "Sub Total" || data.row.raw[0] === "Total") {
          data.cell.styles.fontStyle = "bold";
        } else if (
          data.row.raw[1] === "SubTotal" ||
          data.row.raw[1] === "Total Profits" ||
          data.row.raw[1] === "Product Wise Sales" ||
          data.row.raw[1] === "Stock Return" ||
          data.row.raw[1] === "U-Clip Stock Return"
        ) {
          data.cell.styles.fontStyle = "bold";
        }
      },
    });

    doc.save(reportName);
  };
  const checkBussinessPermission = async () => {
    let checkBussinessPermission = await check_Bussiness_Permission();
    let { isAACotton } = checkBussinessPermission;
    if (isAACotton) {
      setIsAACotton(true);
    }
  };

  const {
    companyName,
    dynamicInvMessage,
    reportName,
    criteria,
    criteriaString,
  } = data;
  return (
    <>
      <Row id="app-body-Invoice" className="app-body-Invoice mt-3">
        <Col xs="12">
          <Row>
            <Col xs="6">
              {" "}
              <h2 style={{ marginLeft: "5px" }} className="">
                {isAACotton ? "A.A. COTTON MILLS LTD" : companyName}
              </h2>{" "}
            </Col>
            <Col xs="4">
              <span style={{ marginLeft: "13em" }}>
                <span className=" ">Printed By </span>: (
                <span className="text-success"> {customerName} </span> )
              </span>
            </Col>
            <Col xs="2">
              <span style={{ marginLeft: "0rem" }}>
                <span className=" ">Printed Date </span>: (
                <span className="text-success"> {currentDate} </span> )
              </span>
            </Col>
            <Col xs="8">
              {" "}
              <h3 style={{ marginLeft: "5px" }} className="">
                {dynamicInvMessage}
              </h3>{" "}
            </Col>
            <Col xs="4">
              <div style={{ textAlign: "end" }}>
                {
                  //Friday 13 Dec, 2024  previous print set Conditionally and
                  //New Print PDF button added by Muhammad Ahmad On all reports With Reports Criteria
                }
                {data.hidePdfBtn > 0 ? (
                  <button
                    className="btn btn-primary mx-2"
                    id="printPageButton"
                    onClick={() => {
                      window.document.title = reportName;
                      window.print();
                    }}
                  >
                    Print to PDF!
                  </button>
                ) : (
                  <Button className="btn btn-warning" onClick={downloadPDF}>
                    Print PDF
                  </Button>
                )}
                <button
                  className="btn btn-secondary m-1"
                  id="printPageButton"
                  onClick={() => {
                    goBackFun();
                  }}
                >
                  Back
                </button>
              </div>{" "}
            </Col>

            <Col xs="12">
              <p style={{ marginLeft: "5px" }}>
                <b>Data Criteria: {criteriaString}</b>
              </p>
              {/* {criteria?.map((element, index) => (
                <>
                  <span>
                    {element?.label +
                      ": " +
                      element?.value +
                      (index === criteria?.length - 1 ? "" : ", ")}{" "}
                  </span>
                  {index == 3 ? <br></br> : null}
                </>
              ))} */}
            </Col>
            {screenTableData.length > 0 ? (
              <Col xs="12">
                <ReactstrapTable
                  data={screenTableData}
                  headers={props?.location?.state?.headers}
                  username={props?.location?.state?.username}
                  headerKeyMap={props?.location?.state?.headerKeyMap}
                  totalBold={props?.location?.state?.totalBold}
                />
              </Col>
            ) : (
              <p>Loading data...</p>
            )}
            <Col xs="12">
              <p>
                * <span className="text-danger">Note </span>: All figures
                indicated are in the company's currency (
                <span className="text-success"> {companySymbolCurrency} </span>{" "}
                ) .{" "}
              </p>
            </Col>
          </Row>
          <br></br>
        </Col>
      </Row>
    </>
  );
}
